import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_i-dots",
  "use": "svg_i-dots-usage",
  "viewBox": "0 0 4 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 4 18\" id=\"svg_i-dots\"><g fill=\"currentColor\" fill-rule=\"evenodd\"><circle cx=\"2\" cy=\"16\" r=\"2\" /><circle cx=\"2\" cy=\"9\" r=\"2\" /><circle cx=\"2\" cy=\"2\" r=\"2\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol